export const USUARIO_AUTENTICADO = 'USUARIO_AUTENTICADO';
export const LOGIN_EXITOSO = 'LOGIN_EXITOSO';
export const CASO_BASE = 'CASO_BASE';